import { useEffect, Suspense } from 'react';
import { createBrowserRouter, RouterProvider, Navigate, useParams } from 'react-router-dom';
import { useSessionStore } from './store/sessionStore.js';
import PwaShell from './components/layout/PwaShell.js';
import WorkstationPage from './pages/workstation/WorkstationPage.js';
import ScanPage from './pages/workstation/ScanPage.js';
import StateHistoryPage from './pages/workstation/StateHistoryPage.js';
import ProductionHistoryPage from './pages/workstation/ProductionHistoryPage.js';
import SettingsPage from './pages/workstation/SettingsPage.js';
import OperatorsPage from './pages/workstation/OperatorsPage.js';

function ProductionHistoryRoute() {
  const { type } = useParams<{ type: string }>();
  if (type !== 'PRODUCED' && type !== 'REJECT' && type !== 'RATE') return <Navigate to="/workstation" replace />;
  return <ProductionHistoryPage type={type} />;
}

function Spinner() {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#1a1a2e' }}>
      <div className="w-10 h-10 border-2 border-blue-400 border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

function ContextLoader({ children }: { children: React.ReactNode }) {
  const loadContext = useSessionStore(s => s.loadContext);
  useEffect(() => { loadContext().catch(() => {}); }, [loadContext]);
  return <>{children}</>;
}

const router = createBrowserRouter([
  { path: '/', element: <Navigate to="/workstation" replace /> },
  { path: '/workstation/scan', element: <ScanPage /> },
  {
    path: '/workstation',
    element: (
      <ContextLoader>
        <PwaShell />
      </ContextLoader>
    ),
    children: [
      { index: true, element: <WorkstationPage /> },
      { path: 'states', element: <StateHistoryPage /> },
      { path: 'production/:type', element: <ProductionHistoryRoute /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'operators', element: <OperatorsPage /> },
    ],
  },
  { path: '*', element: <Navigate to="/workstation" replace /> },
]);

export default function App() {
  return (
    <Suspense fallback={<Spinner />}>
      <RouterProvider router={router} />
    </Suspense>
  );
}
